/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const InfoFilled = (props) => (
  <SvgIcon
    style={{
      width: '16px',
      height: '16px',
    }}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{props.title}</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="messages"
        transform="translate(-108.000000, -385.000000)"
        fill={props.fill}
        fillRule="nonzero"
      >
        <g id="info" transform="translate(108.000000, 385.000000)">
          <path
            d="M8,16 C12.4183,16 16,12.4183 16,8 C16,3.58172 12.4183,0 8,0 C3.58172,0 0,3.58172 0,8 C0,12.4183 3.58172,16 8,16 Z M7,5 C7,4.44772 7.44772,4 8,4 C8.55228,4 9,4.44772 9,5 C9,5.55228 8.55228,6 8,6 C7.44772,6 7,5.55228 7,5 Z M7,8 C7,7.44772 7.44772,7 8,7 C8.55228,7 9,7.44772 9,8 L9,11 C9,11.5523 8.55228,12 8,12 C7.44772,12 7,11.5523 7,11 L7,8 Z"
            id="info-path-1"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

InfoFilled.propTypes = {
  title: PropTypes.string,
  fill: PropTypes.string,
};

InfoFilled.defaultProps = {
  title: '',
  fill: '#4EBFDC',
};

export default InfoFilled;
